import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Briefing Pool · Your Source for Insights</p>
        <h1>Welcome to Briefing Pool.</h1>
        <p className="lede">
          Discover a world of curated insights and information tailored just for you. Our platform connects you with the latest trends and essential knowledge to stay informed and ahead.
        </p>
        <div className="cta-row">
          <a href="/about" target="_blank">
            Learn More
          </a>
          <a href="/subscribe" target="_blank" className="secondary">
            Join Our Community
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Stay Informed</h2>
          <p>
            Access a wealth of resources and insights that keep you updated on the topics that matter most to you.
          </p>
        </article>
        <article>
          <h2>Engage with Experts</h2>
          <p>
            Connect with industry leaders and thought influencers through our interactive content and discussions.
          </p>
        </article>
        <article>
          <h2>Personalized Experience</h2>
          <p>
            Tailor your content feed to match your interests and preferences, ensuring you receive the most relevant information.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;